// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"Rating_ratingContainer__R8LFq","customFontSize":"Rating_customFontSize__czdUo"};